import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import {
  FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED,
  RESPONSIBLE_MANAGERS_LIMIT,
} from '../../Form.constants'
import { isFormErrorNameResponsibleManagersLimitExceeded } from '../../Form.utils'

export function useFormResponsibleManagersLimitErrorNotification({
  errors,
  limit = RESPONSIBLE_MANAGERS_LIMIT,
  responsibleManagersFieldName,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  useEffect(() => {
    if (responsibleManagersFieldName) {
      if (
        isFormErrorNameResponsibleManagersLimitExceeded(
          errors[responsibleManagersFieldName]
        )
      ) {
        onSetNotification({
          id: FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED,
          text: t('Error.ResponsibleManagersLimitExceededErrorKey', {
            limit,
          }),
          type: NOTIFICATION_TYPE.error,
        })
      } else {
        onRemoveNotification(
          FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED
        )
      }
    }
  }, [errors, limit, responsibleManagersFieldName])
}
